module.exports = __webpack_public_path__ + "static/media/co.884797ba.svg";